import withMainLayout from 'layouts/main';
import Link from '@/links';
import dynamic from 'next/dynamic';

// Hero Component import
import InnerPartnerPagesHeroSection from '@/content/partnership-program/shared-components/hero-section';

// Dynamic Content Components import
const WhyWorkable = dynamic(
  import('@/content/partnership-program/channel-partners/why-workable/index'),
  {
    loading: () => null
  }
);
const GettingStarted = dynamic(
  import('@/content/partnership-program/channel-partners/getting-started/index'),
  {
    loading: () => null
  }
);
const InterestToImpact = dynamic(
  import('@/content/partnership-program/channel-partners/interest-to-impact/index'),
  {
    loading: () => null
  }
);
const JoinOurNetworkSection = dynamic(
  import('@/content/partnership-program/shared-components/join-our-network'),
  {
    loading: () => null
  }
);
const PreFooter = dynamic(() => import('@/prefooter'), {
  loading: () => null
});
const seoMetas = {
  title: 'Workable partnerships | Become a Workable Channel partner',
  description:
    'Learn more about how we collaborate with our Channel partners and help them succeed.',
  canonical: 'https://www.workable.com/partnership-program/channel-partners',
  ogimage: 'https://www.workable.com/static/images/workable-partners-social-share.png'
};

const prefooterContent = {
  backgroundImg: 'prefooter-bg-partners.jpg',
  title: 'Explore Workable partnerships',
  subtitle:
    'Ready to grow your customer-base, tap into new networks and help your clients find and hire the best talent?'
};

const ChannelPartnersPage = () => (
  <>
    <InnerPartnerPagesHeroSection
      title="Partner with a leading HR and ATS platform to drive faster growth"
    />
    <WhyWorkable />
    <GettingStarted />
    <InterestToImpact />
    <JoinOurNetworkSection variant="channel-partners" />
    <PreFooter {...prefooterContent}>
      <Link href="/partnership-program/apply" variant="primary-sm">
        Partner with us
      </Link>
    </PreFooter>
  </>
);

export default withMainLayout(ChannelPartnersPage, {...seoMetas});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
